import { spaceClient } from './client';

export const getPortals = () =>
  spaceClient.get('/cms/portal').then((r) => r.data);

export const getPortalTypes = () =>
  spaceClient.get('/cms/portal-types').then((r) => r.data);

export const getEventTypes = () =>
  spaceClient.get('/cms/event-types').then((r) => r.data);

export const createPortal = (portalDto) =>
  spaceClient.post('/portal', portalDto).then((r) => r.data);

export const deletePortal = (portalId) =>
  spaceClient.delete(`/portal/${portalId}`).then((r) => r.data);

export const updatePortalLinks = (portalId, portalDto) =>
  spaceClient.put(`/portal/${portalId}`, portalDto).then((r) => r.data);

export const updatePortal = (boothId, portalId, portalDto) =>
  spaceClient.put(`/booth/${boothId}/portal/${portalId}`, portalDto).then((r) => r.data);

export const getPortalsByBooth = (boothId) =>
  spaceClient.get(`/cms/booth/${boothId}/portals`).then((r) => r.data);

export const deletePortalFromBooth = (boothId, portalId) =>
  spaceClient.delete(`/booth/${boothId}/portal/${portalId}`).then((r) => r.data);

export const getPortalById = (portalId) =>
  spaceClient.get(`/cms/portal/${portalId}`).then((r) => r.data);

export const convertPortalToMedia = (boothId, portalId, mediaDto) =>
  spaceClient.post(`/booth/${boothId}/portal/${portalId}/convert-to-media`, mediaDto).then((r) => r.data);

export const convertPortalToCustom = (boothId, portalId, dto) =>
  spaceClient.post(`/booth/${boothId}/portal/${portalId}/convert-to-custom`, dto).then((r) => r.data);
